import { render, staticRenderFns } from "./ConfigurationCost.vue?vue&type=template&id=0d734538"
import script from "./ConfigurationCost.vue?vue&type=script&lang=js"
export * from "./ConfigurationCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports